module.exports = __webpack_public_path__ + "e2677724fa78516d4ad78c276c96831d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/sports-clubhouse-empty.png
// module id = 331
// module chunks = 0